import { apiRequest } from './client.js';

export interface Site {
  id: string;
  client_id: string;
  name: string;
  address: string | null;
  criticality: 'Z0' | 'Z1' | 'Z2' | 'Z3' | null;
  metadata: Record<string, unknown>;
}

export const sitesApi = {
  listOfClient: (clientId: string) =>
    apiRequest<{ sites: Site[] }>(`/api/v1/clients/${clientId}/sites`),
  create: (
    clientId: string,
    input: { name: string; address?: string; criticality?: 'Z0' | 'Z1' | 'Z2' | 'Z3' | null },
  ) =>
    apiRequest<Site>(`/api/v1/clients/${clientId}/sites`, {
      method: 'POST',
      body: input,
    }),
  get: (id: string) => apiRequest<Site>(`/api/v1/sites/${id}`),
};
